import React, { useEffect, useState } from "react"
import { fetchNodeData } from "utils/common-fetchData"

const STATS = [
  { key: "total", label: "Total", color: "#5b2178" },
  { key: "approved", label: "Approved", color: "#087a42" },
  { key: "unapproved", label: "Unapproved", color: "#c62b2b" },
  { key: "pending", label: "Pending", color: "#a95709" },
  { key: "average", label: "Avg / Month", color: "#245fbd" },
]

const styles = {
  card: {
    border: "1px solid #e6e8ef",
    borderRadius: "10px",
    background: "#fafbfd",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "7px 14px",
    borderBottom: "1px solid #e6e8ef",
    fontSize: "12px",
    fontWeight: 600,
    color: "#495057",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: `repeat(${STATS.length}, 1fr)`,
  },
  cell: isLast => ({
    padding: "8px 6px",
    textAlign: "center",
    borderRight: isLast ? "none" : "1px solid #e6e8ef",
  }),
  value: color => ({
    fontSize: "17px",
    fontWeight: 700,
    lineHeight: 1.2,
    color,
  }),
  label: {
    fontSize: "11px",
    color: "#74788d",
    marginTop: "2px",
    whiteSpace: "nowrap",
  },
}

const formatDays = value => {
  const num = Number(value) || 0
  return Number.isInteger(num) ? num : num.toFixed(1)
}

// Leave counts (approved / unapproved / pending) for an employee over the last few months
const LeaveStatsSummary = ({ userId, months = 6, refreshKey }) => {
  const [stats, setStats] = useState(null)

  useEffect(() => {
    if (!userId) return
    const fetchStats = async () => {
      const res = await fetchNodeData(
        null,
        `leaveStats/${userId}?months=${months}`,
        ""
      )
      setStats(res?.success ? res.data : null)
    }
    fetchStats()
  }, [userId, months, refreshKey])

  if (!userId) return null

  const values = { ...stats?.totals, average: stats?.average }

  return (
    <div className="col-12 mb-2" style={styles.card}>
      <div style={styles.header}>
        <span>
          <i className="bx bx-bar-chart-alt-2 me-1" />
          Leave Summary
        </span>
        <span style={{ color: "#74788d", textTransform: "none" }}>
          Last {months} Months (days)
        </span>
      </div>
      <div style={styles.grid}>
        {STATS.map((stat, i) => (
          <div key={stat.key} style={styles.cell(i === STATS.length - 1)}>
            <div style={styles.value(stat.color)}>
              {formatDays(values[stat.key])}
            </div>
            <div style={styles.label}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LeaveStatsSummary
